<template>
  <button
    type="button"
    class="flex h-10 min-w-10 cursor-pointer items-center justify-center rounded-xl border border-stone-200/90 bg-white/90 px-2 text-xs font-semibold tracking-wide text-stone-800 hover:border-amber-500/45 hover:text-amber-900 dark:border-white/10 dark:bg-white/[0.06] dark:text-[#dfc06e] dark:hover:border-[rgba(242,216,150,0.4)] dark:hover:text-[#f2d896]"
    :aria-label="$t('lang.toggle')"
    :title="$t('lang.toggle')"
    @click="toggle"
  >
    {{ locale === 'en' ? $t('lang.en') : $t('lang.ua') }}
  </button>
</template>

<script setup lang="ts">
const { locale, setLocale } = useI18n()

async function toggle() {
  await setLocale(locale.value === 'en' ? 'ua' : 'en')
}
</script>
